import { CLAIMS } from "../../../constants";


import {
    getMaintenanceNotificationThunkAction,
} from "../../../redux/actions/User/Notification/thunk/getMaintenanceNotification.thunk.action";
import { fetchClaimsThunk } from "../../../redux/actions/User/User Claims/thunk/fetchClaimsThunk";

import { Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";

const DocumentsOnlyRoute = () => {
    const claims = useSelector((state) => state.user?.claims);
    const hasDocumentsOnly = claims && claims.includes(CLAIMS.HAS_DOCUMENTS);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getMaintenanceNotificationThunkAction());
        if (!claims || !claims.length) {
            dispatch(fetchClaimsThunk());
        }
    }, []);
    return hasDocumentsOnly ? <Navigate to="/documents" /> : <Outlet />;
};

export default DocumentsOnlyRoute;
